import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface EnsureAdminResponse {
  created: boolean;
  /** Backend-DTO {@see App\Dto\Response\Auth\BootstrapEnsureAdminResponse}. */
  reason?: 'already_exists' | 'no_admin_password_configured' | 'mandant_not_found' | 'race_lost';
}

@Injectable({ providedIn: 'root' })
export class BootstrapService {
  private readonly http = inject(HttpClient);

  ensureAdmin(): Observable<EnsureAdminResponse> {
    return this.http.get<EnsureAdminResponse>('/bootstrap/ensure-admin');
  }
}
